import React from 'react'
import styled from 'styled-components'
import Typography from '@mui/material/Typography'

const SelectedContributionCount = styled(Typography)<{ $visible: boolean }>`
  visibility: ${({ $visible }) => ($visible ? 'visible' : 'hidden')};

  @media only screen and (max-width: 700px) {
    display: none;
  }
`

interface CardSelectedCountProps {
  count: number
}

const CardSelectedCount = ({ count }: CardSelectedCountProps) => {
  return (
    <SelectedContributionCount variant="body2" $visible={count > 0}>
      {count} {count === 1 ? 'contribution' : 'contributions'} selected
    </SelectedContributionCount>
  )
}

export default CardSelectedCount
